// All site copy & structured data for the Favor Studio AI Dispatcher landing page.

export const NAV_SERVICES = [
  { label: "AI Dispatcher", href: "/", tag: "Live" },
  { label: "Custom AI Builds", href: "/custom-ai-builds", tag: "" },
  { label: "Case Studies", href: "/case-studies", tag: "" },
  { label: "Insights", href: "/insights", tag: "" },
  { label: "Contact", href: "/contact", tag: "" },
];

export const NAV_SECONDARY = [
  { label: "How it works", href: "#how-it-works" },
  { label: "Voices", href: "#voices" },
  { label: "Pricing", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
];

export const TRUST_STATEMENT = "Built specifically for residential HVAC.";

// Live Call Simulation — emergency HVAC call. Ava (AI) + caller.
const R2_CALL_SIM = "https://pub-8c8c614701f24e3baf47754209ce6e4b.r2.dev/favor-studio-ai-receptionist/live-call-simulation";

export const CALL_SCRIPT = [
  { speaker: "ai", name: "Ava", text: "Thanks for calling Davison & Sons Heating and Air. This is Ava — how can I help?", audio: `${R2_CALL_SIM}/ava-live-call-1.mp3` },
  { speaker: "caller", name: "Caller", text: "Yeah, our AC just stopped working. It's 90 degrees in here and we have two kids. Can someone come out today?", audio: `${R2_CALL_SIM}/caller-live-call-1.mp3` },
  { speaker: "ai", name: "Ava", text: "Absolutely. I can help get that scheduled. Is the system completely off, or is it running but not cooling?", audio: `${R2_CALL_SIM}/ava-live-call-2.mp3` },
  { speaker: "caller", name: "Caller", text: "It's running, but it's blowing hot air.", audio: `${R2_CALL_SIM}/caller-live-call-2.mp3` },
  { speaker: "ai", name: "Ava", text: "Got it. We can have a technician take a look. I have an opening between 2 and 4 PM today. Can I get your address and best callback number?", audio: `${R2_CALL_SIM}/ava-live-call-3.mp3` },
  { speaker: "caller", name: "Caller", text: "Sure — 214 Oak Street, and my cell is 555‑0142.", audio: `${R2_CALL_SIM}/caller-live-call-3.mp3` },
  { speaker: "ai", name: "Ava", text: "Perfect. You're booked for 2 to 4 PM today at 214 Oak Street. We'll have the technician contact you with an arrival update. Anything else?", audio: `${R2_CALL_SIM}/ava-live-call-4.mp3` },
  { speaker: "caller", name: "Caller", text: "No, that's great. Thank you.", audio: `${R2_CALL_SIM}/caller-live-call-4.mp3` },
  { speaker: "ai", name: "Ava", text: "You're very welcome. We'll get you taken care of.", audio: `${R2_CALL_SIM}/ava-live-call-5.mp3` },
];

// Fallback per-line display duration, used only if a line's audio fails to load.
CALL_SCRIPT.forEach((l, i) => { l.ms = [4200, 5200, 4800, 2600, 5600, 3600, 5600, 2400, 3400][i] || 4000; });

export const PROBLEM_STATS = [
  { value: "62%", label: "of calls to small businesses go unanswered" },
  { value: "85%", label: "of people won't call back if you miss them" },
  { value: "67%", label: "of missed callers call a competitor" },
];

export const STEPS = [
  {
    n: "01",
    icon: "PhoneCall",
    title: "We learn your business",
    body: "Complete one onboarding document covering your HVAC services, service area, hours, emergency rules, scheduling rules, pricing, policies, FAQs, and escalation rules. We use it to train your AI Dispatcher on your exact business and playbook.",
  },
  {
    n: "02",
    icon: "Wand2",
    title: "We build & test your AI front desk",
    body: "We handle the entire setup — including your AI Dispatcher's dedicated phone number, CRM and scheduling integrations, voice, call flows, booking rules, dispatch rules, SMS and email workflows, and escalation logic. You test it with real scenarios and calls before it goes live.",
  },
  {
    n: "03",
    icon: "Rocket",
    title: "Your AI front desk goes live",
    body: "Your dedicated AI Dispatcher starts answering calls 24/7, qualifying customers, answering questions, booking appointments, and dispatching the right technician with the job details they need. When something requires your attention, it can send you the conversation context and transfer the call directly to you.",
  },
];

const R2_VOICES = "https://pub-8c8c614701f24e3baf47754209ce6e4b.r2.dev/favor-studio-ai-receptionist/here-more-voices";

export const PERSONAS = [
  {
    id: "janet",
    name: "Janet",
    tagline: "The Warm Welcome",
    voice: "Warm • Female • Approachable",
    img: "/avatars/ava.jpg",
    accent: "#2C3E50",
    line: "Thanks for calling Davison & Sons — this is Janet. Sounds like your furnace quit overnight? Let's get someone out to you today.",
    dur: 5200,
    audioSrc: `${R2_VOICES}/janet-ai-voice-receptionist.mp3`,
  },
  {
    id: "marcus",
    name: "Marcus",
    tagline: "The Steady Pro",
    voice: "Confident • Male • Reassuring",
    img: "/avatars/marcus.jpg",
    accent: "#2C3E50",
    line: "Thanks for calling Davison & Sons Heating & Air — this is Marcus. I can help get your AC service scheduled. Are you looking for the soonest available appointment?",
    dur: 5200,
    audioSrc: `${R2_VOICES}/marcus-ai-voice-receptionist-2.mp3`,
  },
  {
    id: "grace",
    name: "Grace",
    tagline: "The Calm Reassurer",
    voice: "Calm • Female • Composed",
    img: "/avatars/grace.jpg",
    accent: "#2C3E50",
    line: "Hi, this is Grace with Davison & Sons Heating & Air. I saw your inquiry on our site. Is your system completely down, or is it running but not cooling?",
    dur: 5200,
    audioSrc: `${R2_VOICES}/grace-ai-voice-receptionist-2.mp3`,
  },
];

export const REALWORLD_MARQUEE = [
  "Handles emergency AC & no‑heat calls",
  "Qualifies your service area",
  "Books maintenance & tune‑ups",
  "Screens new system inquiries",
  "Talks over interruptions",
  "Hears through background noise",
  "Books straight into your calendar",
  "Takes detailed messages",
  "Answers in your brand voice",
  "Works nights, weekends & holidays",
  "Escalates real emergencies to you",
];

export const REALWORLD_CARDS = [
  {
    icon: "MessageSquareWarning",
    title: "Interruptions",
    body: "A homeowner talks over her mid‑sentence, changes their mind about the appointment time, rambles about the noise their unit's making. She keeps up, stays polite, and gets the job booked.",
  },
  {
    icon: "Volume2",
    title: "Background noise",
    body: "Barking dogs, road noise, a running AC unit in the background. She listens through the chaos and still gets the address and callback number right.",
  },
  {
    icon: "Brain",
    title: "Complex asks",
    body: "A no‑cool call that turns into questions about maintenance plans, service‑area coverage, and pricing — all in one conversation. She reasons it out instead of freezing up.",
  },
];

export const GUARDRAILS = [
  { icon: "ShieldCheck", title: "Your data stays yours", body: "Call recordings and customer info are encrypted and never sold. Full transcripts in your dashboard." },
  { icon: "SlidersHorizontal", title: "You're in control", body: "Set exactly what she can and can't say, which jobs to book, and when to hand off to a human." },
  { icon: "PhoneForwarded", title: "Real emergencies reach you", body: "Define what counts as urgent — gas leaks, floods, no‑heat calls — and she rings your cell instantly." },
  { icon: "FileText", title: "Every call logged", body: "Searchable transcripts, recordings, and outcomes. Nothing slips through the cracks, ever." },
];

export const PRICING = {
  human: {
    label: "Full‑time receptionist",
    price: "$65,000",
    per: "/year",
    note: "≈ $5,417/mo · one desk, 40 hrs a week",
    points: ["9–5 only, one call at a time", "Sick days, holidays & turnover", "Salary, taxes & benefits on top", "Weeks to hire and train"],
  },
  ai: {
    label: "Favor AI Dispatcher",
    pilot: { label: "Standard implementation", price: "$3,500" },
    tiers: [
      { label: "To Start", price: "$1,750" },
      { label: "Upon Delivery", price: "$1,750" },
    ],
    points: ["24/7/365, never sleeps", "Answers on the first ring", "Handles unlimited calls at once", "Designed to be deployed within 14 days"],
  },
};

// Missed‑call ROI calculator defaults.
export const ROI = {
  callsMin: 1,
  callsMax: 40,
  callsDefault: 10,
  jobMin: 100,
  jobMax: 5000,
  jobStep: 50,
  jobDefault: 500,
  weeksPerMonth: 4.33,
  bookingRate: 0.3,
};

export const FAQS = [
  { q: "Will my customers know it's an AI?", a: "Most don't — she sounds natural, warm, and human. We can also have her introduce herself as your virtual assistant if you'd prefer full transparency. Your call." },
  { q: "What if she can't answer something?", a: "Your AI Dispatcher is extensively trained on your offer, common customer questions and objections, your services, prices, policies, availability, and has access to your calendar and CRM. On rare occasions, if there are questions it can't answer, it takes a detailed message, texts it to you, then transfers the call to your cell for anything marked as urgent." },
  { q: "Do I need to change my phone number?", a: "No. We give your AI Dispatcher its own operational phone number." },
  { q: "How long until it's working?", a: "It's designed to be deployed within 14 days. We learn your business, build your voice, run test calls with you, and then deploy your AI Dispatcher." },
  { q: "Can she book jobs into my calendar?", a: "Yes. Your AI Dispatcher confirms with the customer over the phone. She books them directly into your scheduling tool, and sends you the details by text and email, automatically." },
  { q: "What does it cost?", a: "Every HVAC business has different call volume and workflow requirements. The standard implementation is $3,500, which covers the setup, training, phone number, and operating system that allows your AI Dispatcher to be available for your customer calls, 24/7, booking your services around the clock." },
];

// Cal.com booking link.
export const CAL_LINK = "favor-studio/favor-studio-ai-receptionist-demo";

// Live Case Study recording (R2) — the real Cape Coral, FL appliance-repair call.
export const CASE_STUDY_AUDIO = "https://pub-8c8c614701f24e3baf47754209ce6e4b.r2.dev/favor-studio-ai-receptionist/ai-hvac-receptionist.mp3";

// Live Call Simulation avatars (R2)
export const AVA_IMAGE = "https://pub-8c8c614701f24e3baf47754209ce6e4b.r2.dev/favor-studio-ai-receptionist/live-call-simulation/ava-the-ai-receptionist.jpg";
export const CALLER_IMAGE = "https://pub-8c8c614701f24e3baf47754209ce6e4b.r2.dev/favor-studio-ai-receptionist/live-call-simulation/live-simulation-caller-headshot.jpg";
